import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { ContentBody, VeteranAppIdHeader } from 'areas/shared/components';
import { Form } from 'fw/forms';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'
import BankInfoItem from './BankInfoItem';
import * as FormManager from 'fw/forms/form/FormManager';

class BankInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        return { form: this.props.stepData };
    }

    componentDidMount() {
        if (this.state.form.bankAccountsList.length === 0) {
            this.addBankAccount(0);
        }
    }

    updatePostData = (form, dirty) => {

        this.setState({ form });
        this.props.onStepChange(form);

        if (dirty === true && this._form !== null)
            FormManager.dirt(this._form);
    }

    privileges() {
        return {
            edit: App.hasPrivilege("AdminAppManagementEdit")
        }
    }

    urls() {
        return {
            get: API.Admin.url('/certification/getBankingInfo'),
            save: API.Admin.url('/certification/saveBankingInfo'),
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId,
            queueTypeCode: this.form.queueTypeCode
        }
    }

    saveRequest() {
        return {
            certificationId: this.state.form.certificationId,
            reviewStatus: this.state.form.reviewStatus,
            reviewUploads: this.state.form.reviewUploads,
            reviewQueueTypeCode: this.state.form.certificationQueueTypeCode,
            bankAccountsList: this.state.form.bankAccountsList
        }
    }

    isEnabled(data) {
        return !data.isReviewFinished;
    }

    ready = () => {
        // Add a phone control to be filled
        if (this.state.form.phones !== undefined && this.state.form.phones.length === 0)
            this.handleAddPhone();
        this.focusControl && this.focusControl.focus();
    }

    addBankAccount = () => {
        let id = -Math.abs(Date.now() | 0);

        let item = {
            entityId: id,
            bankingId: id,
            phones: [
                {
                    phoneTypeCode: "MOBILE",
                    number: "",
                    extension: "",
                    phoneId: -Math.abs(Date.now() | 0)
                }
            ],
            reviewUploads: [
                {
                    upload: {
                        uploadKey: "BankResolution"
                    }
                },
                {
                    upload: {
                        uploadKey: "BankingSignatureCard"
                    }
                },
                {
                    upload: {
                        uploadKey: "CancelledChecks"
                    }
                }
            ],
            otherDocuments: []
        }

        let form = this.state.form
        form.bankAccountsList = form.bankAccountsList.concat(item)

        this.updatePostData(form)
    }

    removeBankAccount = (index) => {
        let form = this.state.form;

        form.bankAccountsList.splice(index, 1);

        this.updatePostData(form, true);
    }

    onUpdateBankAccountsList = (index, item) => {
        let form = this.state.form;

        form.bankAccountsList[index] = item;
        this.updatePostData(form, true);
    }

    render() {
        return (
            <Form
                onChange={this.updatePostData}
                values={this.state.form}
                unsavedChangesWarning={true}
                disabled={this.props.stepInfo.readonly}
                ref={(form) => { this._form = form }}>
                <div>
                    <ContentBody>
                        <Row>
                            <Col md={12}>
                                <Row>
                                    <Col md={12}>
                                        <h3 style={{ position: 'relative' }}>
                                            Banking Information – <small>Please submit all required Banking Documents</small>
                                            <VeteranAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.stepInfo.daysOpen} />
                                        </h3>
                                        <hr />
                                    </Col>
                                </Row>
                                <BankInfoItem
                                    bankAccountsList={this.state.form.bankAccountsList}
                                    onUpdateBankAccountsList={this.onUpdateBankAccountsList}
                                    queueTypeCode={this.state.form.certificationQueueTypeCode}
                                    addBankAccount={this.addBankAccount}
                                    removeBankAccount={this.removeBankAccount}
                                    tooltips={this.props.stepInfo.tooltips}
                                />
                            </Col>
                        </Row>
                    </ContentBody>
                </div>
            </Form>
        )
    }
}

export default BankInfo; 



// WEBPACK FOOTER //
// ./src/areas/certification/steps/bankInfo/BankInfo.js